var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tabs",staticClass:"c-tab-container"},[_c('div',{staticClass:"c-tabs"},_vm._l((_vm.tabList),function(item,index){return _c('span',{key:item.title,class:_vm.activeIndex===index?'active':'',on:{"click":function($event){return _vm.changeIndex(index)}}},[_c('b',[_vm._v(_vm._s(item.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }